import './plot-description.scss';
import { h } from 'preact';

const { __ } = wp.i18n;

function PlotDescription({ description, descriptionHtml }) {
	return (
		<div class="plot-description-container plot-section-container">
			<h3 class="plot-description-header plot-section-header">{__('Description', 'real-estate-project')}</h3>
			{descriptionHtml ?
				<div
					class="plot-description-text-container" dangerouslySetInnerHTML={{
						__html: descriptionHtml
					}}
				/> :
				<div class="plot-description-text-container">
					<p>{description}</p>
				</div>
			}
		</div>
	);
}

export default PlotDescription;